import {BackendError} from "@common-core/runtime-js/backend";
import {ClientEntity} from "@common-core/coat-operational-hierarchy-appsync-model";
import {TriggerResult} from "../../amplify/hooks/types";
import {LookupClientEntityData} from "./LookupClientEntity";

export const assertClientEntityPresent = (
  result: TriggerResult<LookupClientEntityData>
): ClientEntity => {
  if (!result.data?.entity) {
    throw new BackendError(`Client entity not found`, 404);
  }
  return result.data.entity;
};
